import qweBaseField from "../BaseField"
import { queryOptions } from "@/apis/httpHelper";
import _ from "lodash";
import { ChoiceOptionsDefaultType } from "@/common/constant";
import { qweIsEmpty } from "../../../common/commonHelper";

window.Lodash = _;

export default {
    mixins: [qweBaseField],
    data:function(){
        return {
            isSelect:false,
            isAddable:false,
            isFilterAble:false,
            emptyValue:null,

            localQuery:false,
            showState:false,
            loading:false,

            reComputedOptions:false,

            options:[]
        }
    },

    filterOptionsFunc:{},
    scriptOptionsFunc:{},
    localOptions:[],
    

    created:function(){
        this.isAddable = this.selfSetting.Addable;
        this.isFilterAble = this.selfSetting.Addable ? true : this.selfSetting.Filterable;
        this.isSelect = this.selfSetting.DisplayTypeValue !== 0;

        this.handleOptionsFuncScript();

        let self = this;
        let optionsRely = this.selfSetting.ChoiceOptions.RelyFields || [];
        
        this.initValueToLabel();

        this.changeOptions(true);

        optionsRely.forEach(x => {
            this.$watch("data." + x, function (newVal, oldVal) {
                if(self.isSelect){
                    self.reComputedOptions = true;
                }
                else{
                    self.changeOptions();
                }
            })
        });
    },
    methods:{
        initValueToLabel:function(){
            if(!qweIsEmpty(this.data[this.name])){
                if(this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.DataLinkage || this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.RelationForm){

                }
            }
        },

        changeOptions: function (init = false) {
            switch (this.selfSetting.ChoiceOptions.DefaultValueType) {
                case ChoiceOptionsDefaultType.Custom:
                    this.optionCustomFun();
                    break;
                case ChoiceOptionsDefaultType.DataLinkage:
                    this.optionRelyValueFun(init);
                    break;
                case ChoiceOptionsDefaultType.RelationForm:
                    this.optionRelationFormFun(init);
                    break;
                case ChoiceOptionsDefaultType.Formula:
                    this.optionFormulaExpression(init);
                    break;
                default:
                    break;
            }
        },

        handleOptionsFuncScript: function () {
            switch (this.selfSetting.ChoiceOptions.DefaultValueType) {
                case ChoiceOptionsDefaultType.Custom:
                    break;
                case ChoiceOptionsDefaultType.DataLinkage:
                    this.filterOptionsFunc = new Function("Context", "Content", "self", this.selfSetting.ChoiceOptions.RelySettingString);
                    break;
                case ChoiceOptionsDefaultType.RelationForm:
                    break;
                case ChoiceOptionsDefaultType.Formula:
                    this.scriptOptionsFunc = new Function("Context", "Content", "self", "initState" , this.selfSetting.ChoiceOptions.Script);
                    break;
                default:
                    break;
            }
        },

        optionCustomFun:function(){
            let optionsResult = this.selfSetting.ChoiceOptions.CustomOptions;
            this.setOptions(optionsResult);
            this.localQuery = true;
        },

        optionRelyValueFun:function(init, filter){
            let context = this.buildFormContext();
            let computedfilter = this.filterOptionsFunc(context, this.data, this);
            
            if(filter == undefined){
                this.getRemoteOptions(computedfilter);
            }
            else{
                let filterValue = {"logic":"and","filters":[computedfilter,filter]}
                this.getRemoteOptions(filterValue);
            }
        },

        optionRelationFormFun:function(init,filter){
            if(filter == undefined){
                this.getRemoteOptions();
            }
            else{
                this.getRemoteOptions(filter);
            }
        },

        optionFormulaExpression:function(initState){
            let context = this.buildFormContext();
            let optionsResult = this.scriptOptionsFunc(context, context.Content, this, initState);
            if(optionsResult != undefined){
                this.setOptions(optionsResult, initState);
                this.localQuery = true;
            }
        },

        handlerValueWhenChangeOptions:function(){
            if(!this.isAddable){
                if(this.options.filter(x=>x.Value === this.data[this.name]).length == 0){
                    this.data[this.name] = ""
                }
            }
            else{
                let hasValue = this.options.filter(x=>x.Value === this.data[this.name]).length > 0
                if(!hasValue){
                    this.options.push({
                        "value":this.data[this.name],
                        "label":this.data[this.name],
                        "Value":this.data[this.name],
                        "Label":this.data[this.name]
                    })
                }
            }
        },

        setOptions:function(optionsResult, initState){
            optionsResult = optionsResult || [];
            let error =  optionsResult.length != Array.from(new Set(optionsResult.map(x=>x.Value))).length;
            if(error){
                console.log(this.displayName + "-" + this.name + "下拉数据异常，待选项里面包含重复的key");
                optionsResult = _.uniqBy(optionsResult,"Value");
            }
            optionsResult = optionsResult.filter(x=>x.Value != null || x.Label != null);
            optionsResult.forEach(x => {
                x.label = x.Label,
                x.value = x.Value
            });
            this.localOptions = optionsResult;
            this.options = optionsResult.filter(x=> true);
            if(!initState){
                this.handlerValueWhenChangeOptions();
                if(this.$refs.Select != undefined){
                    this.$refs.Select.initOptions(optionsResult);
                }
            }
        },

        getRemoteOptions:function(filter){
            queryOptions(
                this.selfSetting.ChoiceOptions.QueryContentType,
                JSON.stringify(filter),
                this.selfSetting.ChoiceOptions.QueryValue,
                this.selfSetting.ChoiceOptions.QueryLabel
            ).then(x=>{
                let optionsResult = x.Result.Options.map(result=> { 
                    return { 
                        "Label": result[this.selfSetting.ChoiceOptions.QueryLabel],
                        "Value": result[this.selfSetting.ChoiceOptions.QueryValue],
                    }
                });
                this.localQuery = optionsResult.length == x.Result.Total;
                this.setOptions(optionsResult);
                this.loading = false;
            }).catch(x=>{
                console.log(this.displayName + "-" + this.name + "数据获取异常");
                console.log(x)
            })
        },

        filterFun:function(queryString){
            let self = this;
            self.loading = true;
            if(this.localQuery){
                this.options = this.localOptions.filter(x=> x.Label.indexOf(queryString) > -1);
                self.loading = false;
            }
            else{
                let selffilter = {
                    "logic":"and",
                    "filters":[{ 
                        "field":this.selfSetting.ChoiceOptions.QueryLabel,
                        "operator":"contains",
                        "value":queryString
                    }]
                };
                if(this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.DataLinkage) {
                    this.optionRelyValueFun(false, selffilter);
                }
                if(this.selfSetting.ChoiceOptions.DefaultValueType == ChoiceOptionsDefaultType.RelationForm){
                    this.optionRelationFormFun(false, selffilter);
                }
            }
        },

        cleanFilter:function(){
            //本地查询 不用重新赋值
            //非本地的 要求重新计算，把计算状态放到下一次打开下拉框
            if(this.localQuery){
                this.options = this.localOptions;
            }
            else{
                this.reComputedOptions = true;
            }
        },

        visibleChange:function(dropDownState){
            //显示下拉框
            if(dropDownState){
                //是否重新计算下拉选项
                if(this.reComputedOptions){
                    this.changeOptions();
                    this.reComputedOptions = false;
                }
            }
            //隐藏下拉框
            else{
                //this.cleanFilter();
            }
        }
    }
}